export default function GreenCardSection() {
  return (
    <section id="greencard" class="py-5 bg-light-gradient">
      <div class="container py-5">
        <div class="section-title greencardrenewal">
          <h2 class="mb-3">Green Card Renewal, <span style={{fontWeight:'bold'}}>I-90</span></h2>
          <p>Keep Your Permanent Resident Status Current And Valid</p>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <div class="mb-5 animate-on-scroll">
              <h3 class="mb-4">Why Renew Your Green Card?</h3>
              <p>
                A valid Green Card is essential for employment, travel, and
                proving your permanent resident status. Renewing before
                expiration prevents complications with employers, banks, and
                government agencies.
              </p>
              <p>
                USCIS recommends starting the renewal process 6 months before
                your Green Card expires. USCIS processing times vary, and
                starting early may help you receive your new card before
                expiration.
              </p>
            </div>

            <div class="animate-on-scroll">
              <h3 class="mb-4">Renewal Process</h3>
              <div class="process-steps">
                <div class="process-step greencard-step">
                  <div class="step-number">1</div>
                  <div class="step-content">
                    <h4>Initial Consultation</h4>
                  </div>
                </div>
                <div class="process-step greencard-step">
                  <div class="step-number">2</div>
                  <div class="step-content">
                    <h4>Document & Evidence</h4>
                  </div>
                </div>
                <div class="process-step greencard-step">
                  <div class="step-number">3</div>
                  <div class="step-content">
                    <h4><span style={{fontWeight:'bold'}}>Form I-90</span> Completion</h4>
                  </div>
                </div>
                <div class="process-step greencard-step">
                  <div class="step-number">4</div>
                  <div class="step-content">
                    <h4>Attorney Review</h4>
                  </div>
                </div>
                <div class="process-step greencard-step">
                  <div class="step-number">5</div>
                  <div class="step-content">
                    <h4>Submission & Tracking</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-highlight greencard-highlight animate-on-scroll">
              <h3 class="mb-4">Important Renewal Information</h3>
              <p>
                After filing <span style={{fontWeight:'bold'}}>Form I-90</span>, you'll receive a receipt notice (
                  <span style={{fontWeight:'bold'}}>Form
                I-797</span>) that may extend the validity of your expiring Green Card
                for 24 months. This extension serves as temporary proof of your
                lawful permanent resident status while your renewal is being
                processed.
              </p>
              <p>
                If you no longer have your Green Card and you need evidence of
                your lawful permanent resident status while waiting to receive
                your replacement Green Card, you may request an appointment at a
                USCIS Field Office by contacting the <b>USCIS Contact Center</b>
                , and USCIS may issue you an Alien Documentation, Identification,
                and Telecommunications (ADIT) stamp after you file <span style={{fontWeight:'bold'}}>Form I-90</span>.
              </p>
              <ul>
                <li>Keep your expired Green Card with the extension notice</li>
                <li>Present both documents to employers and officials</li>
                <li>Notify USCIS, within 10 days, if your address changes</li>
                <li>Processing time is typically 12-18 months</li>
              </ul>
            </div>

            <div class="row mt-4">
              <div class="col-md-6 mb-3">
                <div class="greencard-highlight animate-on-scroll">
                  <div class="d-flex align-items-center mb-3">
                    <i
                      class="fas fa-undo fa-2x me-3"
                      style={{ color: "var(--secondary)" }}
                    ></i>
                    <h4 class="mb-0">Standard Renewal</h4>
                  </div>
                  <p>For permanent residents whose cards are expiring</p>
                  <a
                    href="#requestform"
                    class="btn btn-outline-primary mt-3"
                    aria-label="button"
                  >
                    Start Now
                  </a>
                </div>
              </div>
              <div class="col-md-6">
                <div class="service-highlight greencard-highlight animate-on-scroll">
                  <div class="d-flex align-items-center mb-3">
                    <i
                      class="fas fa-search fa-2x me-3"
                      style={{ color: "var(--secondary)" }}
                    ></i>
                    <h4 class="mb-0">Card Replacement</h4>
                  </div>
                  <p>For lost, stolen, or damaged Green Cards</p>
                  <a
                    href="#requestform"
                    class="btn btn-outline-primary mt-3"
                    aria-label="button"
                  >
                    Start Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
